module.exports = "/images/vendor/tui-image-editor/dist/svg/icon-b.svg?d70663d06bd44437c178f522047470cc";